module.exports = __webpack_public_path__ + "img/1-1.3aa04cb9.png";